import { Form } from "antd";
import styles from "./index.module.css";
import dayjs, { Dayjs } from "dayjs";
import { DatePickerComponent } from "Components/DatePickerComponent";

export type FromToType = { from: Dayjs; to: Dayjs };
export type TypeOfChange = "transfer" | "return";
type Props = {
  isCompenstation: boolean;
  blocked?: {
    isTransferBlocked?: boolean;
    isReturnDateBlocked?: boolean;
  };
  returnAct?: string;
  openConfirmDateModal: (isOpen: boolean, type: TypeOfChange, newDates: FromToType) => void;
  valueDates: FromToType;
  dateFrom: string;
};

export const DateChooseComponent = ({
  isCompenstation,
  openConfirmDateModal,
  valueDates,
  blocked,
  returnAct,
  dateFrom,
}: Props) => {
  const disabledDate = (current: Dayjs) => {
    const minReturnDate = dayjs(dateFrom).subtract(1, "day");
    return current < minReturnDate;
  };

  const disabledDateReturn = (current: Dayjs) => {
    const minReturnDate = dayjs(valueDates.from).subtract(1, "day");
    return current < minReturnDate;
  };
  return (
    <Form.Item className={styles.transReturnDate} style={!isCompenstation ? { marginBottom: 16 } : null}>
      <Form.Item name={["date", "transferDate"]} label="Transfer Date" className={styles.labelFormFont}>
        <DatePickerComponent
          className={styles.date}
          format={{ format: "DD.MM.YYYY" }}
          disabled={blocked?.isTransferBlocked}
          disabledDate={disabledDate}
          onChange={(_, dateString: string) => {
            const dateJs = dayjs(new Date(dateString.split(".").reverse().join("-")));
            openConfirmDateModal(true, "transfer", { from: dateJs, to: valueDates.to });
          }}
          allowClear={false}
        />
      </Form.Item>
      <Form.Item name={["date", "returnDate"]} label="Return Date" className={styles.labelFormFont}>
        <DatePickerComponent
          className={styles.date}
          format={{ format: "DD.MM.YYYY" }}
          disabled={blocked?.isReturnDateBlocked}
          disabledDate={disabledDateReturn}
          onChange={(_, dateString: string) => {
            const dateJs = dayjs(new Date(dateString.split(".").reverse().join("-")));
            openConfirmDateModal(true, "return", { from: valueDates.from, to: dateJs });
          }}
          allowClear={false}
        />
      </Form.Item>
      {returnAct && <div className={styles.returnAct}>Return Act {returnAct}</div>}
    </Form.Item>
  );
};
